import * as fragments from './fragments'
import * as sections from './section-queries'

export const getSettings = groq`
  * [_type == "settings" && language == $language][0] {
  errorPage {
    title,
    text,
    callToAction {
      ${fragments.link}
      },
    ${fragments.media},
  }
}
`

export const getNavigation = groq`*[_type == "navigation" && language == $language][0] {
  logo,
  megaMenu[] {
    ...,
    items[] {
      ...,
      items[] {
        ${fragments.link}
      }
    },
    ${fragments.media},
    socialMediaCard[] {
      ${fragments.socialMediaCard},
    }
  },
  burgerMenu {
    links[] {
      ${fragments.link}
    },
    arrowLinks[] {
      ${fragments.link}
    },
    ${fragments.media},
  },
  callToAction[] {
    ${fragments.link}
  },
  searchSuggestions,
  searchSuggestionsText,
  showSearch,
}`

export const getColorThemes = groq`
  * [_type == "colorSetting"] {
  name,
  _id,
  'handle':  handle.current,
  'variables': {...${fragments.theme}},
}
`

export const getFooter = groq`
  *[_type == "footer" && language == $language][0] {
    Logo,
    title,
    columns[] {
      title,
      menuItems[] {
        ${fragments.link}
      }
    },
    text,
    additionalLinks[] {
      ${fragments.link}
    },
    copyright,
    cvr,
    managedBy,
  }
`

export const getLanguage = groq`
  * [_type == "language" && language == $language] {
  ...
}
`

export const getPages = groq`
  * [_type == "page" && language == $language] {
    ...,
  "slug": '/' + slug.current,
  }
`

export const getFrontpage = groq`*[_type == "frontpage" && language == $language][0] {
  ...${fragments.pageDefaults},
  'hero': hero{...${sections.hero}},
  ${sections.builder},
  ${fragments.seo}
}`

export const getPage = groq`* [slug.current == $slug && language == $language][0] {
  ...${fragments.pageDefaults},
  ${sections.builder},
  ${fragments.seo},
  ${fragments.parents},
  ...select(
    _type == 'area' => {
      'type': 'area',
      'hero': select(
        defined(parent) => pageHero{
          ...${sections.hero}
        },
        !defined(parent) => ${sections.areaHero}
      ),
    },
    _type == 'education' => {
      'type': 'education',
      'hero': hero{
        ...${sections.hero}
      },
    },
    _type == 'page' || _type == 'person' => {
      'type': 'page',
      'hero': hero{
        ...${sections.hero}
      },
    },
  ),
}`

export const getArea = groq`* [_type == "area" && slug.current == $slug && language == $language][0] {
  ...${fragments.pageDefaults},
  ${sections.areaHero},
  ${fragments.parents},
  ${sections.builder}
}`

export const getArticle = groq`* [slug.current == $slug && language == $language][0] {
  'hero': {
    title,
    publishedAt,
    content[] {
      ...,
      _type == "video" => {
        asset->
      }
    },
    'tag': tag{
      ${fragments.tag}
    },
    'media':${fragments.media},  
  },
  ${fragments.relatedArticles},
  ${fragments.seo},
  ${sections.builder},
}`

export const getAllArticles = groq`
  * [_type == "article"  && language == $language] | order(publishedAt desc) {
    'tag': tag{
      ${fragments.tag}
    },
    'media':${fragments.media},  
    title,
    seo,
    publishedAt,
  }
`

export const getPageTranslationURLs = groq`* [slug.current == $slug][0] {
  "_translations": * [_type == "translation.metadata" && references(^._id)].translations[].value -> {
    'slug': '/' + slug.current,
    language
  },
} `

export const getPagesFromIds = groq`* [_type in $documentTypes && _id in $ids && language == $language] {
    ...${fragments.pageDefaults},
} `
